import React from "react";
import clsx from "clsx";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import parseAndFormat from "../../../../components/texts/parseAndFormat";
import parseToFloat from "../../../../components/texts/parseToFloat";
import {useAllocationOverviewStyles} from "../../../../common/styles/allocationStyles";

const useStyles = useAllocationOverviewStyles;

const tableHeadings = [
    "Fulfillment status",
    "Requirement",
    "Required volume",
    "Joint fulfillment IN",
    "Allocated (L15)",
    "Remaining volume",
];

// const tableRows = new Array(10).fill(tableRow);

interface Props {
    requirement_quantities: any;
}

interface OverViewParamProps {
    general_mandate: number;
    general_req_vol: number;
    general_rel_vol: number;
    fame_advanced: number;
    hvo_hro_advanced: number;
    fame: number;
    hvo_hro: number;
    above_mandate_req_by_cust: number;
    above_mandate_after_fulfill: number;
    vol_not_applicable_to_mandate: number;
    out_joint_fulfillment: number;
}

interface OverViewReqParamProps {
    general_mandate: number;
    general_req_vol: number;
    general_rel_vol: number;
    fame_advanced: number;
    hvo_hro_advanced: number;
    fame: number;
    hvo_hro: number;
    above_mandate_req_by_cust: number;
    above_mandate_after_fulfill: number;
    vol_not_applicable_to_mandate: number;
    out_joint_fulfillment: number;
}

interface OverViewProps {
    req_vol: OverViewReqParamProps;
    joint_fulfill: OverViewParamProps;
    allocated_LE: OverViewParamProps;
    allocated_15: OverViewParamProps;
    offroad_surplus: OverViewParamProps;
    remaining_vol: OverViewParamProps;
}

interface OverviewTableProps {
    step: number;
    data: OverViewProps;
}

const OverviewTable: React.FC<OverviewTableProps> = ({
                                                         step,
                                                         data
                                                     }) => {
    const classes = useStyles();

    const getStatus = (remaining: any) => {
        if (remaining > 0) { return "Not Complete"; }
        if (remaining < 0) { return "Overallocated"; }
        return "Complete";
    };

    const getResult = (reqVol: any, allocatedLE: any, remainingVol: any) => {
        if (isNaN(allocatedLE) && isNaN(remainingVol)) {
            allocatedLE = 0;
            remainingVol = parseToFloat(reqVol.toString()) - allocatedLE;
        }
        return ((parseToFloat(reqVol.toString()) + parseToFloat(allocatedLE.toString()) === 0) || reqVol.toString() === "?")
            ? "Not relevant"
            : parseToFloat(remainingVol.toString()) > 0
                ? "NOT fulfilled"
                : parseToFloat(remainingVol.toString()) < 0
                    ? "Over-allocated"
                    : "Mandate fulfilled";
    };

    const setColor = (reqVol: any, allocatedLE: any, remainingVol: any) => {
        if (isNaN(allocatedLE) && isNaN(remainingVol)) {
            allocatedLE = 0;
            remainingVol = parseToFloat(reqVol.toString()) - allocatedLE;
        }
        return ((parseToFloat(reqVol.toString()) + parseToFloat(allocatedLE.toString()) === 0) || reqVol.toString() === "?")
            ? classes.white
            : parseToFloat(remainingVol.toString()) > 0
                ? classes.red
                : parseToFloat(remainingVol.toString()) < 0
                    ? classes.yellow
                    : classes.darkGreen;
    };

    const setFuelColor = (reqVol: any, allocatedLE: any, remainingVol: any) => {
        if (isNaN(allocatedLE) && isNaN(remainingVol)) {
            allocatedLE = 0;
            remainingVol = parseToFloat(reqVol.toString()) - allocatedLE;
        }
        return parseToFloat(reqVol.toString()) + parseToFloat(allocatedLE.toString()) === 0
            ? classes.white
            : parseToFloat(remainingVol.toString()) > 0
                ? classes.red
                : parseToFloat(remainingVol.toString()) < 0
                    ? classes.yellow
                    : classes.green;
    };

    return (
        <div className={classes.tableContainer}>
            <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                        {tableHeadings.map((heading, hidx) => (
                            <TableCell key={hidx}>{heading}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {step > 0 && (
                        <TableRow
                            style={{
                                border: step === 1 ? "4px solid" : "1px solid",
                            }}
                            className={setColor(
                                data.req_vol.general_req_vol,
                                data.allocated_15.general_req_vol,
                                data.remaining_vol.general_mandate
                            )}
                        >
                            <TableCell style={{
                                fontWeight: step === 1 ? "bold" : "normal",
                                color: step === 1 ? "black" : "grey",
                            }}>{getResult(
                                data.req_vol.general_req_vol,
                                data.allocated_15.general_req_vol,
                                data.remaining_vol.general_mandate
                            )}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 1 ? "bold" : "normal",
                                color: step === 1 ? "black" : "grey",
                            }}>General mandate ({data.req_vol.general_mandate}%)</TableCell>
                            <TableCell style={{
                                fontWeight: step === 1 ? "bold" : "normal",
                                color: step === 1 ? "black" : "grey",
                            }}>{parseAndFormat(data.req_vol.general_req_vol, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 1 ? "bold" : "normal",
                                color: step === 1 ? "black" : "grey",
                            }}>{parseAndFormat(data.joint_fulfill.general_mandate, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 1 ? "bold" : "normal",
                                color: step === 1 ? "black" : "grey",
                            }}>{parseAndFormat(data.allocated_15.general_mandate, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 1 ? "bold" : "normal",
                                color: step === 1 ? "black" : "grey",
                            }}>{parseAndFormat(data.remaining_vol.general_mandate, 2)}</TableCell>
                        </TableRow>
                    )}
                    {step > 1 && (
                        <TableRow
                            style={{
                                border: step === 2 ? "4px solid" : "1px solid",
                            }}
                            className={setColor(
                                data.req_vol.above_mandate_req_by_cust,
                                data.allocated_15.above_mandate_req_by_cust,
                                data.remaining_vol.above_mandate_req_by_cust
                            )}
                        >
                            <TableCell style={{
                                fontWeight: step === 2 ? "bold" : "normal",
                                color: step === 2 ? "black" : "grey",
                            }}>{getResult(
                                data.req_vol.above_mandate_req_by_cust,
                                data.allocated_15.above_mandate_req_by_cust,
                                data.remaining_vol.above_mandate_req_by_cust
                            )}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 2 ? "bold" : "normal",
                                color: step === 2 ? "black" : "grey",
                            }}>Above the mandate (required by customers)</TableCell>
                            <TableCell style={{
                                fontWeight: step === 2 ? "bold" : "normal",
                                color: step === 2 ? "black" : "grey",
                            }}>{parseAndFormat(data.req_vol.above_mandate_req_by_cust, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 2 ? "bold" : "normal",
                                color: step === 2 ? "black" : "grey",
                            }}>{parseAndFormat(data.joint_fulfill.above_mandate_req_by_cust, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 2 ? "bold" : "normal",
                                color: step === 2 ? "black" : "grey",
                            }}>{parseAndFormat(data.allocated_15.above_mandate_req_by_cust, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 2 ? "bold" : "normal",
                                color: step === 2 ? "black" : "grey",
                            }}>{parseAndFormat(data.remaining_vol.above_mandate_req_by_cust, 2)}</TableCell>
                        </TableRow>
                    )}
                    {step > 2 && (
                        <TableRow
                            style={{
                                border: step === 3 ? "4px solid" : "1px solid",
                            }}
                            className={setColor(
                                data.req_vol.out_joint_fulfillment,
                                data.allocated_15.out_joint_fulfillment,
                                data.remaining_vol.out_joint_fulfillment
                            )}
                        >
                            <TableCell style={{
                                fontWeight: step === 3 ? "bold" : "normal",
                                color: step === 3 ? "black" : "grey",
                            }}>{getResult(
                                data.req_vol.out_joint_fulfillment,
                                data.allocated_15.out_joint_fulfillment,
                                data.remaining_vol.out_joint_fulfillment
                            )}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 3 ? "bold" : "normal",
                                color: step === 3 ? "black" : "grey",
                            }}>Joint Fulfillment OUT</TableCell>
                            <TableCell style={{
                                fontWeight: step === 3 ? "bold" : "normal",
                                color: step === 3 ? "black" : "grey",
                            }}>{parseAndFormat(data.req_vol.out_joint_fulfillment, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 3 ? "bold" : "normal",
                                color: step === 3 ? "black" : "grey",
                            }}>{parseAndFormat(data.joint_fulfill.out_joint_fulfillment, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 3 ? "bold" : "normal",
                                color: step === 3 ? "black" : "grey",
                            }}>{parseAndFormat(data.allocated_15.out_joint_fulfillment, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 3 ? "bold" : "normal",
                                color: step === 3 ? "black" : "grey",
                            }}>{parseAndFormat(data.remaining_vol.out_joint_fulfillment, 2)}</TableCell>
                        </TableRow>
                    )}
                    {step > 3 && (
                        <TableRow
                            style={{
                                border: step === 4 ? "4px solid" : "1px solid",
                            }}
                            className={setColor(
                                data.req_vol.above_mandate_after_fulfill,
                                data.allocated_15.above_mandate_after_fulfill,
                                data.remaining_vol.above_mandate_after_fulfill
                            )}
                        >
                            <TableCell style={{
                                fontWeight: step === 4 ? "bold" : "normal",
                                color: step === 4 ? "black" : "grey",
                            }}>{getResult(
                                data.req_vol.above_mandate_after_fulfill,
                                data.allocated_15.above_mandate_after_fulfill,
                                data.remaining_vol.above_mandate_after_fulfill
                            )}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 4 ? "bold" : "normal",
                                color: step === 4 ? "black" : "grey",
                            }}>Above the mandate (after mandate fulfillment)</TableCell>
                            <TableCell style={{
                                fontWeight: step === 4 ? "bold" : "normal",
                                color: step === 4 ? "black" : "grey",
                            }}>{parseAndFormat(data.req_vol.above_mandate_after_fulfill, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 4 ? "bold" : "normal",
                                color: step === 4 ? "black" : "grey",
                            }}>{parseAndFormat(data.joint_fulfill.above_mandate_after_fulfill, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 4 ? "bold" : "normal",
                                color: step === 4 ? "black" : "grey",
                            }}>{parseAndFormat(data.allocated_15.above_mandate_after_fulfill, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 4 ? "bold" : "normal",
                                color: step === 4 ? "black" : "grey",
                            }}>{parseAndFormat(data.remaining_vol.above_mandate_after_fulfill, 2)}</TableCell>
                        </TableRow>
                    )}

                    {step > 4 && (
                        <TableRow
                            style={{
                                border: step === 5 ? "4px solid" : "1px solid",
                            }}
                            className={setColor(
                                data.req_vol.vol_not_applicable_to_mandate,
                                data.allocated_15.vol_not_applicable_to_mandate,
                                data.remaining_vol.vol_not_applicable_to_mandate
                            )}
                        >
                            <TableCell style={{
                                fontWeight: step === 5 ? "bold" : "normal",
                                color: step === 5 ? "black" : "grey",
                            }}>{getResult(
                                data.req_vol.vol_not_applicable_to_mandate,
                                data.allocated_15.vol_not_applicable_to_mandate,
                                data.remaining_vol.vol_not_applicable_to_mandate
                            )}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 5 ? "bold" : "normal",
                                color: step === 5 ? "black" : "grey",
                            }}>Bio volumes not applicable to the mandate</TableCell>
                            <TableCell style={{
                                fontWeight: step === 5 ? "bold" : "normal",
                                color: step === 5 ? "black" : "grey",
                            }}>{parseAndFormat(data.req_vol.vol_not_applicable_to_mandate, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 5 ? "bold" : "normal",
                                color: step === 5 ? "black" : "grey",
                            }}>{parseAndFormat(data.joint_fulfill.vol_not_applicable_to_mandate, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 5 ? "bold" : "normal",
                                color: step === 5 ? "black" : "grey",
                            }}>{parseAndFormat(data.allocated_15.vol_not_applicable_to_mandate, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 5 ? "bold" : "normal",
                                color: step === 5 ? "black" : "grey",
                            }}>{parseAndFormat(data.remaining_vol.vol_not_applicable_to_mandate, 2)}</TableCell>
                        </TableRow>
                    )}
                    {step < 5 && (
                        <>
                            {(() => {
                                const resultFameAdv = getResult(
                                    data.req_vol.fame_advanced,
                                    data.allocated_15.fame_advanced,
                                    data.remaining_vol.fame_advanced
                                );
                                const colorFameAdv = resultFameAdv !== "Not relevant" ? "black" : "grey";

                                return (
                                    <TableRow
                                        className={setFuelColor(
                                            data.req_vol.fame_advanced,
                                            data.allocated_15.fame_advanced,
                                            data.remaining_vol.fame_advanced
                                        )}
                                    >
                                        <TableCell style={{ color: colorFameAdv }}>{resultFameAdv}</TableCell>
                                        <TableCell style={{ color: colorFameAdv }}>Fame</TableCell>
                                        <TableCell style={{ color: colorFameAdv }}>{parseAndFormat(data.req_vol.fame_advanced, 2)}</TableCell>
                                        <TableCell style={{ color: colorFameAdv }}>{parseAndFormat(data.joint_fulfill.fame_advanced, 2)}</TableCell>
                                        <TableCell style={{ color: colorFameAdv }}>{parseAndFormat(data.allocated_15.fame_advanced, 2)}</TableCell>
                                        <TableCell style={{ color: colorFameAdv }}>{parseAndFormat(data.remaining_vol.fame_advanced, 2)}</TableCell>
                                    </TableRow>
                                );
                            })()}
                            {(() => {
                                const resultHvoAdv = getResult(
                                    data.req_vol.hvo_hro_advanced,
                                    data.allocated_15.hvo_hro_advanced,
                                    data.remaining_vol.hvo_hro_advanced
                                );
                                const colorHvoAdv = resultHvoAdv !== "Not relevant" ? "black" : "grey";

                                return (
                                    <TableRow
                                        className={setFuelColor(
                                            data.req_vol.hvo_hro_advanced,
                                            data.allocated_15.hvo_hro_advanced,
                                            data.remaining_vol.hvo_hro_advanced
                                        )}
                                    >
                                        <TableCell style={{ color: colorHvoAdv }}>{resultHvoAdv}</TableCell>
                                        <TableCell style={{ color: colorHvoAdv }}>HVO/HRO</TableCell>
                                        <TableCell style={{ color: colorHvoAdv }}>{parseAndFormat(data.req_vol.hvo_hro_advanced, 2)}</TableCell>
                                        <TableCell style={{ color: colorHvoAdv }}>{parseAndFormat(data.joint_fulfill.hvo_hro_advanced, 2)}</TableCell>
                                        <TableCell style={{ color: colorHvoAdv }}>{parseAndFormat(data.allocated_15.hvo_hro_advanced, 2)}</TableCell>
                                        <TableCell style={{ color: colorHvoAdv }}>{parseAndFormat(data.remaining_vol.hvo_hro_advanced, 2)}</TableCell>
                                    </TableRow>
                                );
                            })()}
                        </>
                    )}

                    {step === 5 && (
                        <>
                            {(() => {
                                const resultFame = getResult(
                                    data.req_vol.fame,
                                    data.allocated_15.fame,
                                    data.remaining_vol.fame
                                );
                                const colorFame = resultFame !== "Not relevant" ? "black" : "grey";

                                return (
                                    <TableRow
                                        className={setFuelColor(
                                            data.req_vol.fame,
                                            data.allocated_15.fame,
                                            data.remaining_vol.fame
                                        )}
                                    >
                                        <TableCell style={{ color: colorFame }}>{resultFame}</TableCell>
                                        <TableCell style={{ color: colorFame }}>FAME</TableCell>
                                        <TableCell style={{ color: colorFame }}>{parseAndFormat(data.req_vol.fame, 2)}</TableCell>
                                        <TableCell style={{ color: colorFame }}>{parseAndFormat(data.joint_fulfill.fame, 2)}</TableCell>
                                        <TableCell style={{ color: colorFame }}>{parseAndFormat(data.allocated_15.fame, 2)}</TableCell>
                                        <TableCell style={{ color: colorFame }}>{parseAndFormat(data.remaining_vol.fame, 2)}</TableCell>
                                    </TableRow>
                                );
                            })()}
                            {(() => {
                                const resultHvo = getResult(
                                    data.req_vol.hvo_hro,
                                    data.allocated_15.hvo_hro,
                                    data.remaining_vol.hvo_hro
                                );
                                const colorHvo = resultHvo !== "Not relevant" ? "black" : "grey";

                                return (
                                    <TableRow
                                        className={setFuelColor(
                                            data.req_vol.hvo_hro,
                                            data.allocated_15.hvo_hro,
                                            data.remaining_vol.hvo_hro
                                        )}
                                    >
                                        <TableCell style={{ color: colorHvo }}>{resultHvo}</TableCell>
                                        <TableCell style={{ color: colorHvo }}>HVO/HRO</TableCell>
                                        <TableCell style={{ color: colorHvo }}>{parseAndFormat(data.req_vol.hvo_hro, 2)}</TableCell>
                                        <TableCell style={{ color: colorHvo }}>{parseAndFormat(data.joint_fulfill.hvo_hro, 2)}</TableCell>
                                        <TableCell style={{ color: colorHvo }}>{parseAndFormat(data.allocated_15.hvo_hro, 2)}</TableCell>
                                        <TableCell style={{ color: colorHvo }}>{parseAndFormat(data.remaining_vol.hvo_hro, 2)}</TableCell>
                                    </TableRow>
                                );
                            })()}
                        </>
                    )}

                    {step < 1 && (
                        <TableRow
                            style={{
                                borderTop: step === 0 ? "4px solid" : "1px solid",
                                color: "grey !important",
                            }}
                            className={setColor(
                                data.req_vol.general_req_vol,
                                data.allocated_15.general_req_vol,
                                data.remaining_vol.general_mandate
                            )}
                        >
                            <TableCell style={{ color: "grey", }}>{getResult(
                                data.req_vol.general_req_vol,
                                data.allocated_15.general_req_vol,
                                data.remaining_vol.general_mandate
                            )}</TableCell>
                            <TableCell style={{ color: "grey", }}>General mandate ({data.req_vol.general_mandate}%)</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.req_vol.general_req_vol, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.joint_fulfill.general_mandate, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.allocated_15.general_mandate, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.remaining_vol.general_mandate, 2)}</TableCell>
                        </TableRow>
                    )}
                    {step < 2 && (
                        <TableRow
                            style={{
                                borderTop: step === 1 ? "4px solid" : "1px solid",
                                color: "grey !important",
                            }}
                            className={setColor(
                                data.req_vol.above_mandate_req_by_cust,
                                data.allocated_15.above_mandate_req_by_cust,
                                data.remaining_vol.above_mandate_req_by_cust
                            )}
                        >
                            <TableCell style={{ color: "grey", }}>{getResult(
                                data.req_vol.above_mandate_req_by_cust,
                                data.allocated_15.above_mandate_req_by_cust,
                                data.remaining_vol.above_mandate_req_by_cust
                            )}</TableCell>
                            <TableCell style={{ color: "grey", }}>Above the mandate (required by customers)</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.req_vol.above_mandate_req_by_cust, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.joint_fulfill.above_mandate_req_by_cust, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.allocated_15.above_mandate_req_by_cust, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.remaining_vol.above_mandate_req_by_cust, 2)}</TableCell>
                        </TableRow>
                    )}
                    {step < 3 && (
                        <TableRow
                            style={{
                                borderTop: step === 2 ? "4px solid" : "1px solid",
                                color: "grey !important",
                            }}
                            className={setColor(
                                data.req_vol.out_joint_fulfillment,
                                data.allocated_15.out_joint_fulfillment,
                                data.remaining_vol.out_joint_fulfillment
                            )}
                        >
                            <TableCell style={{ color: "grey", }}>{getResult(
                                data.req_vol.out_joint_fulfillment,
                                data.allocated_15.out_joint_fulfillment,
                                data.remaining_vol.out_joint_fulfillment
                            )}</TableCell>
                            <TableCell style={{ color: "grey", }}>Joint fulfillment OUT</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.req_vol.out_joint_fulfillment, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.joint_fulfill.out_joint_fulfillment, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.allocated_15.out_joint_fulfillment, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.remaining_vol.out_joint_fulfillment, 2)}</TableCell>
                        </TableRow>
                    )}
                    {step < 4 && (
                        <TableRow
                            style={{
                                borderTop: step === 3 ? "4px solid" : "1px solid",
                                color: "grey !important",
                            }}
                            className={setColor(
                                data.req_vol.above_mandate_after_fulfill,
                                data.allocated_15.above_mandate_after_fulfill,
                                data.remaining_vol.above_mandate_after_fulfill
                            )}
                        >
                            <TableCell style={{ color: "grey", }}>{getResult(
                                data.req_vol.above_mandate_after_fulfill,
                                data.allocated_15.above_mandate_after_fulfill,
                                data.remaining_vol.above_mandate_after_fulfill
                            )}</TableCell>
                            <TableCell style={{ color: "grey", }}>Above the mandate (after mandate fulfillment)</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.req_vol.above_mandate_after_fulfill, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.joint_fulfill.above_mandate_after_fulfill, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.allocated_15.above_mandate_after_fulfill, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.remaining_vol.above_mandate_after_fulfill, 2)}</TableCell>
                        </TableRow>
                    )}
                    {step < 5 && (
                        <TableRow
                            style={{
                                borderTop: step === 4 ? "4px solid" : "1px solid",
                                color: "grey !important",
                            }}
                            className={setColor(
                                data.req_vol.vol_not_applicable_to_mandate,
                                data.allocated_15.vol_not_applicable_to_mandate,
                                data.remaining_vol.vol_not_applicable_to_mandate
                            )}
                        >
                            <TableCell style={{ color: "grey", }}>{getResult(
                                data.req_vol.vol_not_applicable_to_mandate,
                                data.allocated_15.vol_not_applicable_to_mandate,
                                data.remaining_vol.vol_not_applicable_to_mandate
                            )}</TableCell>
                            <TableCell style={{ color: "grey", }}>Bio volumes not applicable to the mandate</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.req_vol.vol_not_applicable_to_mandate, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.joint_fulfill.vol_not_applicable_to_mandate, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.allocated_15.vol_not_applicable_to_mandate, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.remaining_vol.vol_not_applicable_to_mandate, 2)}</TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </div>
    );
};

export default OverviewTable;
